import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import './ICAIMPage.css';

const stats = [
  { value: '100+', label: 'Research Papers', detail: 'High quality papers from around the world', icon: 'document' },
  { value: '54+', label: 'Posters', detail: 'Innovative ideas and research presentations', icon: 'user' },
  { value: '50+', label: 'International Speakers', detail: 'Experts sharing knowledge and insights', icon: 'globe' },
  { value: 'Hybrid', label: 'Conference Mode', detail: 'Join us online or in-person', icon: 'group' },
  { value: 'Viksit Bharat', label: 'Vision Focus', detail: 'Technology driving a developed tomorrow', icon: 'eye' },
];

const themes = [
  {
    title: 'Agriculture',
    description: 'AI, IoT, and automation for precision farming, pest detection, climate forecasting, and sustainable agricultural practices.',
    tone: 'green',
  },
  {
    title: 'Healthcare',
    description: 'Digital innovations, DPI, and AI solutions for better patient care, diagnostics, and sustainable healthcare.',
    tone: 'blue',
  },
  {
    title: 'Information Technology',
    description: 'Emerging technologies, data-driven systems, and robust digital infrastructure driving Viksit Bharat.',
    tone: 'violet',
  },
];

const preConferenceSchedule = [
  { date: '06-02-2025', time: '10.00 am - 11.00 am', topic: 'AI and blockchain in healthcare', speaker: 'Dr. Anand Rao' },
  { date: '06-02-2025', time: '11.00 am - 12.00 noon', topic: "AI's role in medicine", speaker: 'Dr. Sabhyasachi Sengupta' },
  { date: '06-02-2025', time: '1.00 pm - 5.00 pm', topic: 'Hackathon: Driving Changes in Education, Health, and Agriculture Using AI with MATLAB', speaker: 'Judges: Mr. Kunal Khandelwal, Mr. Shrikant Manihar' },
  { date: '03 & 04 Feb 2025', time: 'Workshop', topic: 'App Development using MATLAB', speaker: 'Ms. Kinjal Doshi, Ms. Anamika Dhawan, Ms. Alifiya Shaikh' }
];

const sessionChairs = [
  'Dr. Megharani Patil, Dy. Head of the Department, TCET',
  'Dr. Rekha Sharma, Associate Professor, Computer Science Software Engineering, TCET',
  'Dr. Rashmi Thakur, Associate Professor & Associate Dean, TCET',
  'Dr. Suresh A. Shan, Chairman, CSI - Mumbai Chapter',
  'Dr. Aparna Deshmukh, Head - Biotechnology, TCSC'
];

const paperAwards = [
  { category: 'Faculty - First Winner', title: 'Using AI for Early Detection of CNS anomalies in Fetus in the First Trimester through Sonography Scans to Assist Rural Doctors in India', authors: 'Dr Vinita Gaikwad, Ms. Anamika Dhawan, Dr Padma Mishra' },
  { category: 'Faculty - First Runner up', title: 'AI- Deep Learning Algorithm Based Prediction Model for Heart Disease using ECG images', authors: 'Dr. Ashwini Renavikar, Dr. Sonal Sharma' },
  { category: 'Faculty - First Runner up', title: 'Machine Learning based Disease Prediction & Drug Recommender System', authors: 'Dr. Shiksha Dubey, Mr. Brijesh Pandey' },
  { category: 'Faculty - First Runner up', title: 'Aspect based Sentiment Analysis of Drug Reviews', authors: 'Ms. Kinjal Doshi, Dr. Falguni Parsana' },
  { category: 'Student - First Winner', title: 'Enhancing LLMs with Human-Behavior-Inspired Data', authors: 'Gaud Sonal Sanjay Tarawati, Mojawat Devendra Mohan Sita' },
  { category: 'Student - First Runner up', title: 'Digital Technology and Social Isolation: A Machine Learning Study of Wellbeing Patterns', authors: 'Panda Sanjana Sidhartha Sasmita' },
  { category: 'Student - Second Runner up', title: 'Transforming Primary History Education: Development and Implementation of HistBot, an AI-Powered, Curriculum-Aligned Chatbot', authors: 'Ansari Tahera Kausar Mohd Khurdus Hasina, Choudhary Akash Anil Kiran' },
];

const posterAwards = [
  { category: 'Student - First Winner', title: 'AgriVanni: Preserving and Transforming Farmer Knowledge Through AI', authors: 'Pundkar Hrishikesh, Reddy Karthik, Redkar Sanjana, Rodrigues Royal' },
  { category: 'Student - First Runner up', title: 'Harnessing AI for Sustainable Agriculture in India', authors: 'Mishra Rachana, Mistry Samay, Mishra Rushabh, Mishra Soni' },
  { category: 'Student - Second Runner up', title: 'YourLamp', authors: 'Shelar Vikas Balaji' },
];

const hackathonAwards = [
  { rank: 'First Winner', team: 'Sign Language Recognition' },
  { rank: 'First Runner up', team: 'AgroShield' },
  { rank: 'Second Runner up', team: 'Identification of Plant Disease from Leaf Images Based on Convolutional Neural Network' },
];

const partners = ['AMC', 'MACCIA', 'MMA', 'GIST', 'NCSH'];
const galleryCards = [
 { title: 'Opening Ceremony', src: '/ICAIM/ICAIM 2026/_MCA4270.jpg' },
  { title: 'Main Stage', src: 'https://via.placeholder.com/480x320?text=Main+Stage' },
  { title: 'Audience', src: 'https://via.placeholder.com/480x320?text=Audience' },
  { title: 'Delegates', src: 'https://via.placeholder.com/480x320?text=Delegates' },
  { title: 'Workshop Table', src: 'https://via.placeholder.com/480x320?text=Workshop+Table' }
];
const carouselImages = [
  'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1551818255-e6e10975bc17?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80'
];

const icon = (kind) => {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.9', strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'calendar') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" {...common} /><path d="M8 3v4M16 3v4M3 10h18" {...common} /></svg>;
  if (kind === 'location') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" {...common} /><circle cx="12" cy="10" r="2.5" {...common} /></svg>;
  if (kind === 'screen') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="12" rx="2" {...common} /><path d="M8 21h8M12 17v4" {...common} /></svg>;
  if (kind === 'document') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7V3Z" {...common} /><path d="M14 3v5h5M10 13h6M10 17h6M10 9h2" {...common} /></svg>;
  if (kind === 'user') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" {...common} /><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6" {...common} /></svg>;
  if (kind === 'globe') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" {...common} /><path d="M3 12h18M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3c-2.2 2.4-3.3 5.4-3.3 9S9.8 18.6 12 21" {...common} /></svg>;
  if (kind === 'group') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="9" r="3.2" {...common} /><circle cx="17" cy="10" r="2.6" {...common} /><path d="M3.5 21c.9-3.9 3-6 5.5-6s4.6 2.1 5.5 6M14.5 16c2.4.2 4.2 1.9 5 5" {...common} /></svg>;
  if (kind === 'eye') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" {...common} /><circle cx="12" cy="12" r="3" {...common} /></svg>;
  if (kind === 'arrow') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" {...common} /></svg>;
  if (kind === 'leaf') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14c0-5.5 4.5-10 10-10h4v4c0 5.5-4.5 10-10 10H5v-4Z" {...common} /><path d="M8 16c3-5 6-7 11-10" {...common} /></svg>;
  if (kind === 'medical') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" {...common} /><path d="M12 8v8M8 12h8" {...common} /></svg>;
  if (kind === 'chip') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" {...common} /><path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" {...common} /></svg>;
  if (kind === 'award') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="5" {...common} /><path d="M8.5 13.5 7 21l5-3 5 3-1.5-7.5" {...common} /></svg>;
  return null;
};

const ICAIM2025 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500); // Changes image every 3.5 seconds
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="icaim25Page">
      <Navbar />
      <main className="icaim25Main">
        <section className="icaim25Hero">
          <div className="icaim25HeroShell glass-panel-dark">
            <div className="icaim25HeroGrid" id="icaim25-content">
              <div className="icaim25HeroCopy">
                <span className="icaim25HeroKicker">ICAIM 2025</span>
                <h1 className="icaim25HeroLead">
                  Advances in IT &amp; Management
                </h1>
                <p className="icaim25HeroSubtitle">
                  Theme: "Leveraging Information for Sustainability in Agriculture & Healthcare – Viksit Bharat"
                </p>

                <div className="icaim25HeroMetaInline">
                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('calendar')}</span>
                    <span>8 - 9 February 2025</span>
                  </div>

                  <span className="icaim25MetaSeparator">|</span>

                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('location')}</span>
                    <span>TIMSCDR, Mumbai (Hybrid Mode)</span>
                  </div>
                </div>

                <div className="icaim25HeroActions">
                  <a href="#overview" className="icaim25PrimaryButton text-center" style={{ textDecoration: 'none' }}>
                    <span>Explore Conference</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
                  <a href="#awards" className="icaim25SecondaryButton text-center" style={{ textDecoration: 'none' }}>
                    <span>View Winners</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25StatsSection" id="about">
          <div className="icaim25StatsGrid glass-panel-light">
            {stats.map((stat, index) => (
              <div className="icaim25StatCard" key={stat.label}>
                <div className={`icaim25StatIcon statTone${index + 1}`}>{icon(stat.icon)}</div>
                <div>
                  <div className="icaim25StatValue">{stat.value}</div>
                  <div className="icaim25StatLabel">{stat.label}</div>
                  <div className="icaim25StatDetail">{stat.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25AboutSection" id="overview">
          <div className="icaim25AboutGrid">
            <div className="icaim25SectionIntro">
              <span className="icaim25SectionTag">Conference Overview</span>
              <h2>Technology with real-world sustainability outcomes.</h2>
              <p>
                Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) organized ICAIM 2025 on 8-9 February 2025 in a blended mode. The theme of this year's conference was <strong>“Leveraging Information for Sustainability in Agriculture & Healthcare – Viksit Bharat”</strong>.
              </p>
              <p>
                Organized in association with AMC, MACCIA, MMA, GIST, and NCSH. The conference aims to contribute towards the vision of a Viksit Bharat by driving innovative IT solutions for sustainability and resilience in agriculture and healthcare. The focus was on how IT can enhance productivity, efficiency, and sustainability, inspiring transformative changes for a developed India.
              </p>
            </div>

            <div className="icaim25StageCard glass-panel-light" aria-hidden="true">
              <div className="icaim25StageHeader">ICAIM 2025</div>
              <div className="icaim25StageScreen">
                {/* Carousel Images */}
                <div className="icaim25CarouselTrack">
                  {carouselImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Conference slide ${index + 1}`}
                      className={`icaim25CarouselImg ${index === currentSlide ? 'active' : ''}`}
                    />
                  ))}
                  {/* Overlay overlay to darken images so text is readable */}
                  <div className="icaim25CarouselOverlay"></div>
                </div>
            
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25ThemeSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Theme Focus</span>
          </div>
          <div className="icaim25ThemeGrid">
            {themes.map((theme, index) => (
              <article className={`icaim25ThemeCard tone-${theme.tone}`} key={theme.title}>
                <div className="icaim25ThemeCardIcon">
                  {icon(index === 0 ? 'leaf' : index === 1 ? 'medical' : 'chip')}
                </div>
                <h3>{theme.title}</h3>
                <p>{theme.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="icaim25NarrativeSection" id="events">
          <div className="icaim25CenteredHeading" style={{ marginTop: '50px' }}>
            <span className="icaim25SectionTag">Event Highlights</span>
          </div>
          <div className="icaim25NarrativeGrid">
            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 1 - 8 February 2025</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Inauguration & Agriculture Focus</h3>
              </div>
              <p>
                The inauguration was graced by Chief Guest <strong>Dr. Suresh Shan</strong> (Chairman, CSI), and Guests of Honor <strong>Mr. Jyotish Kumar Ghosh</strong> (Chief Sales Officer, 3i Infotech Ltd), <strong>Mr. Manohar Khake</strong> (Agro Consultant), and <strong>Mr. Yelloji Mirajkar</strong> (International Convenor, GIST). <strong>Dr. Vinita Gaikwad</strong> (Director, TIMSCDR) welcomed the guests, highlighting AI's significance in agriculture and healthcare.
              </p>
              <p>
                <strong>Dr. Prakash Jha</strong> (Mississippi State University) showcased AI in precision farming and climate forecasting. <strong>Dr. Gopal Shinde</strong> (Vasantrao Naik Marathwada Krishi Vidyapeeth) demonstrated Agri bots, drone components, and an RFID-based livestock management system. 
              </p>
              <p>
                The day concluded with a panel discussion on <em>"Leveraging Information Technology for Sustainability in Agriculture – Viksit Bharat"</em> moderated by <strong>Mr. Dinesh Singh</strong> (TCS). Panelists <strong>Mr. Manohar Khake, Dr. Gopal Shinde, Dr. Prakash Jha, and Prof. Sudhakar Umale</strong> discussed climate change, agricultural automation, and the role of AI, Blockchain, and IoT in sustainable solutions.
              </p>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 2 - 9 February 2025</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Healthcare Innovations & DPI</h3>
              </div>
              <p>
                The session was graced by <strong>Dr. Vivek Dwivedi</strong> (President, AMC) and <strong>Dr. Shalin Soni</strong> (President, MMA), emphasizing AI's potential in healthcare. Online international speakers <strong>Mr. Johannes Brundin</strong> and <strong>Mr. Diego Angelino</strong> (NCSH) discussed sustainable healthcare practices. <strong>Dr. Sujata</strong>, <strong>Dr. Mukesh Gupta</strong>, and <strong>Dr. Vikrant Desai</strong> praised the collaborative effort in equipping doctors with IT knowledge.
              </p>
              <p>
                <strong>Mr. Santosh Chapaneri</strong> (Lead Data Scientist, UpToDate) delivered a talk on "AI in Healthcare," emphasizing ethical implementation. 
              </p>
              <p>
                The day featured a robust panel on <em>"Digital Public Infrastructure in Healthcare"</em> moderated by <strong>Dr. Mukesh Gupta</strong>. The panel included <strong>Dr. Vinita Gaikwad, Dr. Sabhyasachi Sengupta, Mr. Vivek Lotlikar, Mr. Santosh Chapaneri, Dr. Vikrant Desai, and Nicholas D’Souza</strong>, focusing on technological advancements and interdisciplinary collaboration to drive future medical innovations.
              </p>
            </article>
          </div>
        </section>

        <section className="icaim25FeatureSection" id="speakers">
          <div className="icaim25FeatureGrid">
            <article className="icaim25DarkPanel glass-panel-dark">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag">Workshops &amp; Hackathon</span>
                <h2>Applied learning across health, AI, and education.</h2>
              </div>
              <div className="icaim25WorkshopGrid">
                <div className="icaim25WorkshopCard highlight-green">
                  <h3>Doctor&apos;s Workshop</h3>
                  <p>Personalized patient engagement with AI, headed by our knowledgeable faculty members of TIMSCDR and attended by doctors from all over Mumbai.</p>
                  <ul>
                    <li>AI assisted videos for Patient Awareness</li>
                    <li>Chatbot for Patients Interaction</li>
                    <li>Data Management with AI</li>
                    <li>AI Generated Digital Visiting card</li>
                  </ul>
                </div>
                <div className="icaim25WorkshopCard highlight-orange">
                  <h3>Hackathon</h3>
                  <p>Driving change in education, health, and agriculture using AI with MATLAB.</p>
                  <div className="icaim25JudgesBlock">
                    <strong>Expert Judges</strong>
                    <span>Mr. Kunal Khandelwal (MathWorks)</span>
                    <span>Mr. Shrikant Manihar (ex-MD, Duck Creek)</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light" id="pre-conference">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-primary)' }}>Pre-Conference</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Expert Sessions & Workshops</h3>
              </div>
              <p style={{ marginBottom: '16px' }}>
                Conducted for students by eminent industry personalities focusing on deep-tech applications in life sciences and rapid application development.
              </p>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Date / Time</th>
                      <th>Topics</th>
                      <th>Speaker / Judges Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConferenceSchedule.map((session, i) => (
                      <tr key={i}>
                        <td><strong>{session.date}</strong><br /><span style={{ fontSize: '0.85em', color: 'var(--icaim-text-muted)' }}>{session.time}</span></td>
                        <td>{session.topic}</td>
                        <td>{session.speaker}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25ResearchSection" id="awards">
          <div className="icaim25CenteredHeading" style={{ marginTop: '80px' }}>
            <span className="icaim25SectionTag">Proceedings & Recognitions</span>
            <h2 style={{ fontSize: '2.2rem', marginTop: '10px' }}>100 Research Papers & 54 Technical Posters</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '700px', margin: '10px auto' }}>
              Selected after a rigorous review process and presented before distinguished professionals from Agriculture, Healthcare, and IT.
            </p>
          </div>

          <div className="icaim25SessionChairs" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '40px' }}>
            {sessionChairs.map((chair, i) => (
              <span key={i} className="icaim25Badge">{chair}</span>
            ))}
          </div>

          <div className="icaim25AwardsStack">
            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Research Paper Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Research Paper Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paperAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('Winner') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Technical Research Poster Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Poster Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {posterAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('Winner') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Hackathon Winners</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Hackathon Team Name / Topic</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hackathonAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.rank.includes('First Winner') ? 'var(--icaim-accent)' : 'inherit' }}>{award.rank}</strong></td>
                        <td>{award.team}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25PartnersSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Our Partners &amp; Associations</span>
          </div>
          <div className="icaim25PartnersGrid">
            {partners.map((partner) => (
              <div className="icaim25PartnerCard glass-panel-light" key={partner}>
                <div className="icaim25PartnerMark">{partner.charAt(0)}</div>
                <div className="icaim25PartnerName">{partner}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25GallerySection" id="gallery">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Glimpses From ICAIM 2025</span>
          </div>
          <div className="icaim25GalleryGrid">
            {galleryCards.map((card, index) => (
              <div className={`icaim25GalleryCard gallery-${index + 1}`} key={card.title}>
                <img
                  src={card.src}
                  alt={card.title}
                  style={{ width: '100%', height: 'auto', borderRadius: '14px', objectFit: 'cover' }}
                />
                <span>{card.title}</span>
              </div>
            ))}
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default ICAIM2025;